import styled from 'styled-components'
import Button from '../../elements/Button'

const FooterButton = styled(Button)`
  width: 120px;
  height: 36px;
  @media(max-width: 767px) {
    width: 100px;
    font-size: 12px;
    height: 24px;
  }
`

export default FooterButton
